import React, { useState } from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

import downloadIcon from "../../assets/Filled-floating-icon.svg";
import "./DownloadPdf.css";

import brochurePdf from '../../assets/Skyline-Brochure.pdf';


const DownloadIcon = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const defaultLayout = defaultLayoutPlugin();

  const openViewer = () => setIsViewerOpen(true);
  const closeViewer = () => setIsViewerOpen(false);

  return (
    <div style={{ textAlign: "center" }}>
      <button
        onClick={openViewer}
        className="download-icon"

        aria-label="View PDF"
      >
        <img src={downloadIcon} alt="View PDF" />
      </button>

      {isViewerOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              position: "relative",
              width: "90%",
              height: "90%",
              backgroundColor: "#fff",
              borderRadius: 8,
              overflow: "hidden",
              boxShadow: "0 0 20px rgba(0, 0, 0, 0.5)",
              padding: 20,
            }}
          >
            <button
              onClick={closeViewer}
              style={{
                position: "absolute",
                padding: "15",
                top: 20,
                bottom: "15",
                right: 10,
                background: "gray",
                border: "none",
                fontSize: 20,
                cursor: "pointer",
              }}
              aria-label="Close PDF viewer"
            >
              &times;
            </button>

            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
              <Viewer
                fileUrl={brochurePdf}
                plugins={[defaultLayout]}
              />
            </Worker>
          </div>
        </div>
      )}
    </div>
  );
};

export default DownloadIcon;
